/**
 * The `ShellConfig` this app hands to `@fiveox/shell`'s SSO helpers.
 *
 * ADR-0024 §5 keeps service URLs out of the package, so the host supplies
 * them — which is also what lets an app repo outside the monorepo consume the
 * same code (ADR-0037 §2).
 */

import type { ShellConfig } from '@fiveox/shell'

import { ACCOUNTS_URL, AUTH_API, SSO_CLIENT_ID } from './config'

/**
 * **Per-app, because storage is per-origin** (SSO_INTEGRATION §3.2). Four core
 * apps each grew their own copy of the deep-link stash with their own key
 * before it moved into the shell; the key stayed per-app deliberately.
 */
export const RETURN_KEY = 'fiveox.prodesk_return_to'

/**
 * Computed at call time, not at module load. `window.location.origin` is what
 * the redirect URI must match, and a value captured at import can be wrong in
 * a test environment or behind a rewritten host.
 */
export function ssoConfig(): ShellConfig {
  return {
    accountsUrl: ACCOUNTS_URL,
    authApiUrl: AUTH_API,
    clientId: SSO_CLIENT_ID,
    redirectUri: `${window.location.origin}/callback`,
  }
}
